export class SimpleParallax {
    private readonly obj = document.querySelectorAll(".js-parallax");
    private readonly windowHeight: number = window.innerHeight;
    private readonly halfWindowHeight: number = window.innerHeight / 2;

    constructor() {
        if (this.obj.length > 0) {
            this.animation();

            // this is must because aos.js
            // setTimeout(() => {
            //     this.animation();
            // }, 300);

            // setTimeout(() => {
            //     this.animation();
            // }, 600);

            // document.addEventListener('scroll', () => {
            //     requestAnimationFrame(() => this.animation());
            // });
        }
    }

    private animation(): void {
        // @ts-ignore
        for (const item of this.obj) {
            let itemOffset = item.getBoundingClientRect().top + item.offsetHeight;
            if (itemOffset < 0 && this.windowHeight < item.getBoundingClientRect().top) {
                return;
            }

            const objOffset = item.dataset.offset || 0.2;
            const finalOffset = objOffset * (itemOffset - this.halfWindowHeight);
            item.style.transform = `translateY(${finalOffset}px)`;
        }

        requestAnimationFrame(() => this.animation());
    }
}
